<template>
  <el-dialog
    :visible.sync="showDialog"
    :width="modalWidth"
    top="25vh"
    :modal-append-to-body="false"
    :before-close="handleClose"
    :close-on-click-modal="false"
    custom-class="custom-scrollable"
  >
    <commission-box @closeDialog="closeDialog" />
  </el-dialog>
</template>

<script>
import breakpoints from '@/utils/breakpoints.js'

export default {
  data () {
    return {
      breakpoints
    }
  },
  props: {
    showDialog: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    closeDialog (amount) {
      this.$emit('closeDialog', amount)
    },
    handleClose () {
      this.$emit('closeDialog')
    }
  },
  computed: {
    modalWidth () {
      return breakpoints.lgAndUp ? '25%' : breakpoints.mdAndUp ? '70%' : '90%'
    }
  },
  components: {
    CommissionBox: () =>
      import('@/components/settings/terminal/CommissionBox.vue')
  }
}
</script>
